$(function() {
    var $titleWrapper = $('.title-wrapper');

    // set line height for vetical align
    $titleWrapper.each(function(i, el) {
        var $el = $(el);

        $el.css({
            lineHeight: $el.outerHeight() + 'px'
        });
    });
});
